import { useState, useEffect } from "react";
import axios from "axios";
import "./items.css";
import { useSelector } from "react-redux";

import { useDispatch } from "react-redux";
import * as Action from "../../../../../store/redux/terminal_reducer.js";
// import from MUI
import IsLoading from "../../../../../IsLoading";
import CloseIcon from "@mui/icons-material/Close";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import EditIcon from "@mui/icons-material/Edit";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";

export default function Items() {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  return (
    <>
      {loading ? (
        <IsLoading />
      ) : (
        <div className="item_row">
          <ItemsList dispatch={dispatch} />
        </div>
      )}
    </>
  );
}

function ItemsList() {
  const [openItemDrpdwn, setOpenItemDrpdwn] = useState(false);
  const [accordion, setAccordion] = useState(null);
  const [brands, setBrands] = useState("All brands");
  const [activeRow, setActiveRow] = useState(null);
  const dispatch = useDispatch();

  const { cart } = useSelector((state) => state.terminalActions.inventoryPOS);

  function popCart(index) {
    if (cart.length < 2) {
      // Because it remove all extra conditional and clear reciept numbers
      dispatch(Action.clearCartAction());
    } else {
      dispatch(Action.removeFromCart(index));
    }
  }
  function updatePackage(index, pkg, available) {
    if (available > 0) {
      setBrands(pkg);
      setOpenItemDrpdwn(false);
      dispatch(Action.updateSwitchPackage({ index, pkg }));
    } else {
      alert("Item out of stock");
    }
  }
  function updateQty(index, qty, available) {
    if (Number(available) >= Number(qty)) {
      if (qty > 0) {
        dispatch(Action.updateQuantity({ index, qty }));
      } else {
        alert("Cannot be less than One item");
      }
    } else {
      alert("Item out of stock:", index);
    }
  }
  function insertQty(index, qty, available) {
    if (Number(available) >= Number(qty)) {
      if (qty > 0) {
        dispatch(Action.insertQuantity({ index, qty }));
      } else {
        alert("Cannot be less than One item");
      }
    } else {
      alert("Item out of stock:", index);
    }
  }

  function handleItemDrpdwn(index) {
    setOpenItemDrpdwn(!openItemDrpdwn);
    if (activeRow === index) {
      setActiveRow(null);
    } else {
      setActiveRow(index);
    }
  }

  return (
    <>
      {cart && cart.length > 0 ? (
        <table className="fx-cl spacem">
          <thead className="fx-cl spacem">
            <tr>
              <th>S/N</th>
              <th>Item</th>
              <th>Base Unit</th>
              <th>Quantity</th>
              <th>Price ₦</th>
              <th>Estimate ₦</th>
            </tr>
          </thead>

          <tbody className="fx-cl spacem">
            {cart.map((item, index) => (
              <tr
                key={index}
                id={`${accordion == index && "itemAccordionOpen"}`}
                className="itemRowTdCont"
              >
                <td
                  id={item?.sku}
                  className={`itemRowTd ${activeRow == index && "active_warehauseRow"}`}
                  onClick={() =>
                    accordion == index
                      ? setAccordion(null)
                      : setAccordion(index)
                  }
                >
                  <span>
                    <strong>{index + 1}</strong>
                  </span>

                  <span>{item?.name}</span>

                  <span>
                    <div className="item_row_entries-info fx-ac spacem">
                      <div className="item_row-page-limit">
                        <button
                          onClick={() => handleItemDrpdwn()}
                          style={{ color: "#222", textTransform: "capitalize" }}
                        >
                          <span className="item_row-page-limit-arrow">
                            {item?.unit}
                          </span>
                        </button>

                        {openItemDrpdwn && activeRow == index && (
                          <ul className="item_row-limit-dropdown">
                            {[
                              "Pieces",
                              "Bundle",
                              "Dosen",
                              "Cattom",
                              "Rim",
                              "Packet",
                              "Torn",
                            ].map((n) => (
                              <li
                                key={n}
                                className="item_row-limit-item"
                                onClick={() =>
                                  updatePackage(index, n, item?.soldQuantity)
                                }
                              >
                                {n}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </div>
                  </span>

                  <span
                    className="fx-ac spacem"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <button
                      onClick={() =>
                        updateQty(
                          index,
                          Number(item?.soldQuantity - 1),
                          item?.inventory?.quantity,
                        )
                      }
                    >
                      <RemoveCircleOutlineIcon
                        fontSize="medium"
                        style={{ color: "#f35e6a" }}
                      />
                    </button>

                    <input
                      className="itemQuanty"
                      type="text"
                      value={item?.soldQuantity}
                      onChange={(event) =>
                        insertQty(
                          index,
                          Number(event.target.value),
                          item?.inventory?.quantity,
                        )
                      }
                    />

                    <button
                      onClick={() =>
                        updateQty(
                          index,
                          Number(item?.soldQuantity + 1),
                          item?.inventory?.quantity,
                        )
                      }
                    >
                      <AddCircleOutlineIcon fontSize="medium" />
                    </button>
                  </span>

                  <span className="fx-ac space1">
                    <span>
                      ₦{item?.pricing?.sellingPrice?.toLocaleString()}
                    </span>
                  </span>

                  <span className="fx-ac space1">
                    <span>
                      ₦
                      {(
                        item?.pricing?.sellingPrice * item?.soldQuantity
                      ).toLocaleString()}
                    </span>
                  </span>

                  <span
                    className="fx-ac space1"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <button
                      className="removeCart"
                      onClick={() => popCart(index)}
                    >
                      <CloseIcon fontSize="large" />
                    </button>
                  </span>
                </td>

                <span className="itemAccordionCont">
                  <div className="itemAccordionDisc fx-ac space1">
                    <figure className="fx-ac fx-jc">
                      <ShoppingCartIcon
                        style={{
                          fontSize: "9.5rem",
                          color: "rgb(233 245 243)",
                        }}
                      />
                    </figure>

                    <div className="itemAccordionDetails g g4 space1">
                      <div className="fx-cl spacem">
                        <span>Brand</span>
                        <p>
                          <strong>{item?.brand}</strong>
                        </p>
                      </div>

                      <div className="fx-cl spacem">
                        <span>Batch</span>
                        <p>
                          <strong>
                            {
                              item?.inventory?.batchTracking?.batches?.[0]
                                ?.batchNo
                            }
                          </strong>
                        </p>
                      </div>

                      <div className="fx-cl spacem">
                        <span>Item SKU</span>
                        <p>
                          <strong>{item?.sku}</strong>
                        </p>
                      </div>

                      <div className="fx-cl spacem">
                        <span>Base Unit</span>

                        <div className="item_row-page-limit">
                          <button
                            onClick={() => handleItemDrpdwn()}
                            style={{
                              color: "#222",
                              textTransform: "capitalize",
                            }}
                          >
                            {item?.unit}
                            <span className="item_row-page-limit-arrow">▾</span>
                          </button>

                          {openItemDrpdwn && activeRow == index && (
                            <ul className="item_row-limit-dropdown">
                              {[
                                "Pieces",
                                "Bundle",
                                "Dosen",
                                "Cattom",
                                "Rim",
                                "Packet",
                                "Torn",
                              ].map((n) => (
                                <li
                                  key={n}
                                  className="item_row-limit-item"
                                  onClick={() =>
                                    updatePackage(index, n, item?.soldQuantity)
                                  }
                                >
                                  {n}
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>
                      </div>

                      <div className="fx-cl spacem">
                        <span>Expiry Date</span>
                        <p>
                          <strong>
                            {
                              item?.inventory?.batchTracking?.batches?.[0]
                                ?.expiryDate
                            }
                          </strong>
                        </p>
                      </div>

                      <div className="fx-cl spacem">
                        <span>Size</span>
                        <p className="fx-ac space2">
                          <strong>L: {item?.size?.length}</strong>
                          <strong> W: {item?.size?.width},</strong>
                          <strong> H: {item?.size?.height}</strong>
                        </p>
                      </div>

                      <div className="fx-cl spacem">
                        <span>Attribute</span>
                        <p>
                          <strong>{item?.attribute}</strong>
                        </p>
                      </div>

                      <div className="fx-cl spacem">
                        <span>Bar Code</span>
                        <p>
                          <strong>{item?.barcode}</strong>
                        </p>
                      </div>
                      <div className="itemsAcorrdingBtns fx-ac space1">
                        <button
                          className="controlButtons"
                          style={{
                            backgroundColor: "#f85a38",
                          }}
                        >
                          <span>Change Unit</span>
                        </button>

                        <button className="controlButtons">
                          <EditIcon />
                          <span>Expiry Info</span>
                        </button>

                        <button className="controlButtons">
                          <WorkspacePremiumIcon />
                          <span>Batch Details</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </span>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div className="fx-ac fx-jc" style={{ height: "100%" }}>
          <p className="pointOfSaleEmpty">Scan Barcode or Add</p>
        </div>
      )}
    </>
  );
}
